// Click-to-copy for contact links (email, phone).
export function setupCopyToClipboard() {
  const links = document.querySelectorAll("[data-copy]");
  if (!links.length) return;

  links.forEach((link) => {
    link.addEventListener("click", async (e) => {
      const value = link.dataset.copy;
      if (!value) return;

      // Allow the default action (mailto:/tel:) to proceed
      // but also copy to clipboard
      try {
        await navigator.clipboard.writeText(value);
      } catch {
        // Fallback for older browsers
        const textarea = document.createElement("textarea");
        textarea.value = value;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      // Show tooltip
      link.classList.add("copy-tooltip--active");
      setTimeout(() => {
        link.classList.remove("copy-tooltip--active");
      }, 1500);
    });
  });
}
